import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';

export default function SignInButton() {
  return (
    <Card bg="light" className="mb-3">
      <Card.Body>
        <Row>
          <Col xs="auto">
            <div
              className="py-3 px-4 rounded border d-none d-md-block"
              style={{ backgroundColor: '#E1E2E4' }}
            >
              <FontAwesomeIcon className="icon-gradient" icon={faLock} size="3x"/>
            </div>
            <div
              className="py-2 px-3 rounded border d-md-none"
              style={{ backgroundColor: '#E1E2E4' }}
            >
              <FontAwesomeIcon className="icon-gradient" icon={faLock} size="2x" />
            </div>
          </Col>
          <Col>
            <p>
              <strong>Get the full picture on this property</strong>
            </p>
            <p>
              Unlock additional property data and research features with a free Prospect By Buildout
              account.
            </p>
            <Button
              className="text-center"
              data-js-start-session-modal="true"
              label="Create an Account"
              variant="secondary"
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
